var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRaiseHand = function SvgRaiseHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.542 14.191a.748.748 0 0 1-.292.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.75a2.25 2.25 0 0 1 4.5 0v.128A2.25 2.25 0 0 1 18 6v.128a2.25 2.25 0 0 1 3 2.122v6.568a7.682 7.682 0 0 1-13.934 4.465l-4.62-6.468a2.388 2.388 0 0 1 3.779-2.917l1.275 1.53V6a2.25 2.25 0 0 1 3-2.122V3.75Zm1.042 10.441A.75.75 0 0 0 12 13.5V3.75a.75.75 0 0 1 1.5 0v9.75a.75.75 0 0 0 1.5 0V6a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 0 1.5 0V8.25a.75.75 0 0 1 1.5 0V14.818A6.182 6.182 0 0 1 8.287 18.41l-4.62-6.468a.888.888 0 0 1 1.405-1.085l2.602 3.122A.75.75 0 0 0 9 13.5V6a.75.75 0 0 1 1.5-.006V13.5a.75.75 0 0 0 .75.75"
  })));
};

export default SvgRaiseHand;